module.exports = __webpack_public_path__ + "img/search.f0a26662.jpg";